export const type = 'form.panel';
